import { render, staticRenderFns } from "./project.vue?vue&type=template&id=4fb41a88&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "./project.vue?vue&type=style&index=0&id=4fb41a88&prod&lang=scss&scoped=true"
import style1 from "./project.vue?vue&type=style&index=1&id=4fb41a88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb41a88",
  null
  
)

export default component.exports